import { render } from "./CompanyView.vue?vue&type=template&id=2397fc2e&scoped=true"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"

import "./CompanyView.vue?vue&type=style&index=0&id=2397fc2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2397fc2e"]])

export default __exports__